export const actions = {
  set_state: 'product_pixel/set_state',
  get_product_pixel: 'product_pixel/get_product_pixel',
  get_product_pixel_qr: 'product_pixel/get_product_pixel_qr',
  delete_product_pixel: 'product_pixel/delete_product_pixel',
  create_product_pixel: 'product_pixel/create_product_pixel'
}
